var map = {
	"./cn/Common.json": "cc7e",
	"./cn/Core/Footer.json": "ec43",
	"./cn/Core/MigrationBanner.json": "e7d2",
	"./cn/Core/Toolbar.json": "1342",
	"./cn/Home.json": "217c",
	"./en/Common.json": "0a2d",
	"./en/Core/Footer.json": "173d",
	"./en/Core/MigrationBanner.json": "cb72",
	"./en/Core/Toolbar.json": "f26b",
	"./en/Home.json": "5cc6",
	"./fr/Core/MigrationBanner.json": "1831"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";